import { useEffect } from "react";

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [key, val] = selector.replace("meta[", "").replace("]", "").split("=");
    el.setAttribute(key, val.replace(/['"]/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel='${rel}']`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * useSEO - lightweight per-page SEO controller.
 * Updates <title>, meta description, OG/Twitter cards, and canonical URL.
 */
export const useSEO = ({ title, description, image, lang = "en" }) => {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      setMeta("meta[name='description']", "content", description);
      setMeta("meta[property='og:description']", "content", description);
      setMeta("meta[name='twitter:description']", "content", description);
    }

    if (title) {
      setMeta("meta[property='og:title']", "content", title);
      setMeta("meta[name='twitter:title']", "content", title);
    }

    if (image) {
      setMeta("meta[property='og:image']", "content", image);
      setMeta("meta[name='twitter:image']", "content", image);
    }

    setMeta("meta[property='og:type']", "content", "website");
    setMeta("meta[property='og:locale']", "content", lang === "zh" ? "zh_HK" : "en_US");
    setMeta("meta[name='twitter:card']", "content", "summary_large_image");

    const url = typeof window !== "undefined" ? window.location.href : "";
    if (url) {
      setMeta("meta[property='og:url']", "content", url);
      setLink("canonical", url);
    }
  }, [title, description, image, lang]);
};

export default useSEO;
